(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  document.querySelectorAll('[data-countdown-midnight]').forEach(function (el) {
    var hoursEl = el.querySelector('[data-unit="hours"]');
    var minutesEl = el.querySelector('[data-unit="minutes"]');
    var secondsEl = el.querySelector('[data-unit="seconds"]');
    if (!hoursEl || !minutesEl || !secondsEl) return;

    function tick() {
      var now = new Date();
      var midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var totalSeconds = Math.max(0, Math.floor((midnight - now) / 1000));

      hoursEl.textContent = pad(Math.floor(totalSeconds / 3600));
      minutesEl.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      secondsEl.textContent = pad(totalSeconds % 60);
    }

    tick();
    setInterval(tick, 1000);
  });
})();
